import { StatsigEnrollmentType } from '@eventbrite/discover-utils';
import {
    GetEnrollmentStatus,
    useClientStatsigEnrollment,
} from '../context/experiments/hooks';

export const useExperimentFlag = (
    experimentName: string,
    paramName: string,
    defaultValue: boolean,
): boolean => {
    const { status, variant } = useClientStatsigEnrollment<boolean>({
        name: experimentName,
        paramName,
        defaultValue,
        enrollmentType: StatsigEnrollmentType.EXPERIMENT,
    });

    if (status === GetEnrollmentStatus.LOADING) {
        return defaultValue;
    }

    return typeof variant === 'string' ? JSON.parse(variant) : variant;
};

export const useShowAttendeeCreatorToggle = (): boolean => {
    return useExperimentFlag(
        'show_nav_intent_toggle_ab',
        'showAttendeeCreatorToggle',
        false,
    );
};
